import { Component } from '@angular/core';

@Component({
  selector: 'tx-unauthenticated-pages-wrapper',
  templateUrl: './unauthenticated-pages-wrapper.component.html',
  styleUrls: ['./unauthenticated-pages-wrapper.component.scss']
})
export class UnauthenticatedPagesWrapperComponent {

}
